module.exports = __webpack_public_path__ + "img/joinCurve1.e5d3122f.svg";